import script from "./ThermalReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./ThermalReceipt.vue?vue&type=script&setup=true&lang=js"

import "./ThermalReceipt.vue?vue&type=style&index=0&id=48ebd7c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ebd7c3"]])

export default __exports__